const tableCellAreas = {
  condition: '¿Realmente desea eliminar este elemento?'
}

export default tableCellAreas;